import { useQuery } from "@tanstack/react-query";
import { SalesOrdersWorkspace } from "@/components/search-sales-orders/SalesOrdersWorkspace";
import { DraftBanner } from "@/components/shared/draft-banner";
import { ErrorState } from "@/components/shared/error-state";
import { PageHeader } from "@/components/shared/page-header";
import { Skeleton } from "@/components/ui/skeleton";
import { fetchSalesOrderLines, searchSalesOrdersKeys } from "@/mocks/search-sales-orders";

export function SearchSalesOrdersPage() {
  const {
    data: lines,
    isLoading,
    isError,
    refetch,
  } = useQuery({
    queryKey: searchSalesOrdersKeys.all,
    queryFn: fetchSalesOrderLines,
  });

  return (
    <div className="space-y-6">
      <DraftBanner
        epic="EPIC-002"
        run="HR-001"
        subtitle="Search Sales Orders — mock order lines, nothing here posts to NetSuite."
      />
      <PageHeader
        title="Sales Orders"
        description="Search for order lines, move the ones you want into Selected for update, describe the change, then apply."
      />
      {isError ? (
        <ErrorState message="Couldn't load sales order lines." onRetry={() => refetch()} />
      ) : isLoading || !lines ? (
        <div className="space-y-4">
          <Skeleton className="h-48 w-full rounded-xl" />
          <Skeleton className="h-64 w-full rounded-xl" />
        </div>
      ) : (
        <SalesOrdersWorkspace lines={lines} />
      )}
    </div>
  );
}
